export default __webpack_public_path__ + "images/T0.98027a4.png";